import { render } from "./JobUpload.vue?vue&type=template&id=20cdddae&scoped=true"
import script from "./JobUpload.vue?vue&type=script&lang=js"
export * from "./JobUpload.vue?vue&type=script&lang=js"

import "./JobUpload.vue?vue&type=style&index=0&id=20cdddae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20cdddae"]])

export default __exports__